import React, { useContext, useEffect, useState } from 'react';
import cn from 'classnames';
import { CustomerContext } from '../../../contexts/CustomerContext';
import Grid from '../../Grid';
import Typography from '../../Typography';
import { Extra } from '../../../models/_models';
import styles from './AddonsSelection.module.sass';
import Button from '../../Button';
import { useHistory } from 'react-router';

const useAddons = () => {
  const { customer, setCustomer } = useContext(CustomerContext);
  const history = useHistory();
  const { currentOrderPackage } = customer;
  const [addons, setAddons] = useState([]);
  const [selected, setSelected] = useState(currentOrderPackage.extras.map(extra => extra.id));

  const addItemsAndNavigate = () => {
    currentOrderPackage
      .save({ with: 'extras' })
      .then(() => {
        setCustomer({ ...customer, currentOrderPackage });
        history.push('/previous_images');
      });
  }

  const addAddon = addon => {
    currentOrderPackage.extras = addons.filter(addon => selected.includes(addon.id)).concat([addon]);
    setSelected(currentOrderPackage.extras.map(extra => extra.id));
  };

  const removeAddon = addon => {
    currentOrderPackage.extras = currentOrderPackage.extras.map(extra => {
      if (extra.id === addon.id) extra.isMarkedForDisassociation = true;

      return extra;
    });

    setSelected(currentOrderPackage.extras.filter(extra => !extra.isMarkedForDisassociation).map(extra => extra.id));
  }

  useEffect(() => {
    Extra
      .includes('prices')
      .where({ optionId: currentOrderPackage.apiOptionId })
      .all()
      .then(res => {
        if (res.data.length === 0) history.push('/previous_images')
        else setAddons(res.data)
      });
  }, [currentOrderPackage.optionId]);

  return {
    addons,
    selected,
    currentOrderPackage,
    addAddon,
    removeAddon,
    addItemsAndNavigate,
  };
};

const AddonsSelection = () => {
  const { addons, selected, addAddon, removeAddon, addItemsAndNavigate } = useAddons();
  const { customer: { currentOrderPackage } } = useContext(CustomerContext)

  if (addons.length === 0) return null;

  const usePriceWithout = currentOrderPackage.price === 0

  return (
    <Grid container direction='column' xs={12} maxWidth='md' style={{ margin: '0 auto' }}>
      <Grid container item direction='column' justify='center' xs={10} classes={styles.section}>
        <Typography tag='h1' align='center' weight={600} classes={styles.title}>Select Any Additional Addons</Typography>
        <Typography align='center'>or</Typography>
        <Button variant='submit' onClick={addItemsAndNavigate}>Continue</Button>
      </Grid>
      {addons.map(addon =>
        <Grid
          container
          item
          xs={10}
          key={addon.id}
          onClick={() => selected.includes(addon.id) ? removeAddon(addon) : addAddon(addon)}
          classes={cn(styles.addon, selected.includes(addon.id) ? styles.selected : styles.unselected)}
        >
          <Grid item xs={8}>
            <Typography weight={600}>
              {selected.includes(addon.id) ? '-' : '+'}{' '}{addon.name}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography align='right' weight={600}>
              {addon.prices.length > 0 && (
                addon.price({ format: 'currency', usePriceWithout })
              )}
            </Typography>
          </Grid>
        </Grid>
      )}
      {/* <Grid container item direction='column' xs={10} classes={styles.section}>
        <Button variant='submit'>Continue</Button>
      </Grid> */}
    </Grid>
  )
};

export default AddonsSelection;
